import type { ListingButtonKind } from '@pulsify/shared/dto'
import {
  BookOpen,
  Globe,
  Instagram,
  type LucideIcon,
  Navigation,
  Phone,
  Share2,
  Utensils,
} from 'lucide-react'
import * as m from '~/paraglide/messages'

export const BUTTON_ICONS: Record<ListingButtonKind, LucideIcon> = {
  lunch_menu: Utensils,
  menu: BookOpen,
  phone: Phone,
  directions: Navigation,
  website: Globe,
  instagram: Instagram,
  share: Share2,
}

export const BUTTON_LABELS: Record<ListingButtonKind, () => string> = {
  lunch_menu: m.listingButtonsKindLunchMenu,
  menu: m.listingButtonsKindMenu,
  phone: m.listingButtonsKindPhone,
  directions: m.listingButtonsKindDirections,
  website: m.listingButtonsKindWebsite,
  instagram: m.listingButtonsKindInstagram,
  share: m.listingButtonsKindShare,
}
